import { useContext } from "react";
import useSWR from "swr";
import { ChasablesContext, ChasableSignalRContext as SignalRContext } from "../context/ChasablesContext";
import { CustomerChaseSummaryModel } from "../models/ChasableModels";
import { ToastContext } from "../context/ToastContext";

export function useCustomerChasables(customerId: string | undefined | null) {
  const { showToast } = useContext(ToastContext);
  const { chasables } = useContext(ChasablesContext);
  const isConnected = !!chasables;
  const { data, isLoading, error } = useSWR(
    isConnected && customerId ? ["GetExternalCustomerChasables", customerId] : null,
    () => SignalRContext.connection?.invoke<CustomerChaseSummaryModel>("GetExternalCustomerChasables", customerId),
    {
      onError: () => {
        showToast("Failed to get chasables, please try again later", "error");
      },
    }
  );

  return {
    chasables: data,
    isLoading: !isConnected || isLoading,
    isError: !!error,
  };
}
